import Reveal from "./Reveal";
import { X } from "lucide-react";

const NOT_FOR = [
  "You want the cheapest possible service.",
  "You want to micromanage every frame.",
  "You aren't willing to invest in quality.",
  "You expect overnight results.",
  "You only care about vanity metrics.",
];

export default function NotFor() {
  return (
    <section className="bg-[#f5f5f7] py-28 sm:py-40" data-testid="not-for-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <span className="eyebrow text-[#86868b]">Honesty first</span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.06] text-[#1d1d1f]">
            We're probably not for you if…
          </h2>
        </Reveal>
        <div className="mt-14 space-y-4 max-w-2xl mx-auto">
          {NOT_FOR.map((item, i) => (
            <Reveal key={item} delay={i * 0.07} y={20}>
              <div
                className="group flex items-center gap-5 rounded-[22px] border border-black/[0.06] bg-white px-6 py-5 shadow-[0_8px_26px_rgba(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_46px_rgba(0,0,0,0.09)] cursor-default"
                data-testid={`notfor-${i + 1}`}
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#f5f5f7] text-[#aeaeb2] transition-colors duration-300 group-hover:bg-[#1d1d1f] group-hover:text-white">
                  <X className="h-4 w-4" strokeWidth={2} />
                </span>
                <span className="text-base sm:text-lg font-medium text-[#1d1d1f]">{item}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
